import { Admin2Unit, AdminUnit, LocatePoint, Option, SearchResponse } from "../../interfaces/dataInterfaces"
import { coreApi } from "./coreApi"

export const geoBoundariesApi = coreApi.injectEndpoints({
  endpoints: builder => ({
    locatePoint: builder.mutation<LocatePoint, { adm0Code: number; long: number; lat: number }>({
      query: params => ({
        url: `GeoBoundaries/LocatePoint`,
        method: "GET",
        params: { adm0Code: params.adm0Code, longitude: params.long, latitude: params.lat },
      }),
    }),

    getCountry: builder.query<Option[], void>({
      query: () => ({ url: "GeoBoundaries/Admins", method: "GET" }),
      providesTags: [{ type: "Country" as const, id: "LIST" }],
    }),

    getAdmin1: builder.query<
      SearchResponse<AdminUnit>,
      { adm0Code: number; skip: number; take: number; search?: string }
    >({
      query: params => ({
        url: `GeoBoundaries/AdminUnitsL1`,
        method: "GET",
        params,
      }),
      providesTags: [{ type: "AdminUnit1" as const, id: "LIST" }],
    }),

    getAdmin2: builder.query<
      SearchResponse<Admin2Unit>,
      { adm0Code: number; skip: number; take: number; search?: string }
    >({
      query: params => ({
        url: `GeoBoundaries/AdminUnitsL2`,
        method: "GET",
        params,
      }),
      providesTags: [{ type: "AdminUnit2" as const, id: "LIST" }],
    }),
  }),
})

export const { useLocatePointMutation, useGetCountryQuery, useGetAdmin1Query, useGetAdmin2Query } = geoBoundariesApi
